export const extractLink = (description: string): string | null => {
  const match = description.match(/Link:\s*(\S+)/);
  return match ? match[1] : null;
};
